import React, { useState } from 'react'
import SplitFlap, { ISplitFlap } from 'components/SplitFlap'
import { prepareData } from 'utils/googleData'

const Feature = ({
    index,
    content,
    perspective = '20rem',
    startDelay = 500,
    ...feature
}: ISplitFlap & { index: number; content: JSX.Element }) => {
    const randomize = feature?.randomize?.toLowerCase?.() === 'true'
    return (
        <li className="flex flex-col items-center justify-center space-y-2 text-center">
            <SplitFlap startDelay={index * startDelay} perspective={perspective} randomize={randomize} {...feature} />
            <div>
                <p dangerouslySetInnerHTML={{ __html: content }} />
            </div>
            {/* <div>{content}</div> */}
        </li>
    )
}

export default function AllInOne(props) {
    const {
        enable,
        title,
        subtitle,
        description,
        cta,
        direction,
        style,
        animationData,
        gatsbyImage,
        startDelay,
        perspective,
        features,
        gatsbyTransformed,
    } = prepareData({ props })
    const delay = parseInt(startDelay, 10)
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <section className="my-16 mx-auto max-w-4xl px-4 md:my-24">
            <h2
                className="m-0 text-center text-4xl leading-tight md:text-6xl md:leading-none"
                dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
            <p className="m-0 mt-4 text-center text-base font-semibold opacity-70 sm:text-lg">{subtitle}</p>
            <ul
                className="m-0 mt-8 grid
             list-none grid-cols-2 items-start gap-y-8 gap-x-4 p-0 sm:grid-cols-4 md:mt-12 md:gap-y-0"
            >
                {features.map((feature, index) => {
                    return (
                        <Feature key={index} index={index} {...feature} startDelay={delay} perspective={perspective} />
                    )
                })}
            </ul>
        </section>
    )
}
